import React from 'react';

const ResultDateAnnouncingScreen = ({ date }: { date?: string }) => {
	return (
		<div className="flex flex-col mx-auto rounded-[8px] justify-center items-center h-full">
			<div className="max-w-md w-full flex flex-col items-center text-center pb-20">
				<div className="max-w-[48px] max-h-[48px] mx-auto">
					<img src="/assets/assessmentcompleted/circle.svg" className="w-full h-full" />
				</div>
				<h1 className="text-[20px] font-inter font-[700] text-[#0A0103] leading-[28px] mt-4">All Set!</h1>
				<div className="space-y-2 text-[#544D4F] text-[16px] leading-[24px] font-[600] mt-3">
					You have successfully completed <br /> your entrance test. <br /> Your results will be available on{' '}
					<span className="text-[#7777E7] text-[16px] font-inter font-[600] leading-[24px]">
						{date}
					</span>
				</div>
			</div>
		</div>
	);
};

export default ResultDateAnnouncingScreen;
